import {isRealSite} from 'src/lib/texas-bounds'

import type {JobLocation} from './types'

export function validateLocation(location: JobLocation, nameLabel = 'Location name') {
    const nameError = location.name.trim() ? undefined : `${nameLabel} is required`
    const latitudeError =
        location.latitude == null || location.longitude == null
            ? 'Location position is required'
            : isRealSite(location.latitude, location.longitude)
              ? undefined
              : 'Coordinates are invalid. Check for a missing decimal point or minus sign'

    return {
        nameError,
        latitudeError,
        isValid: !nameError && !latitudeError,
    }
}
